import useRetrieveIntegrations from '@/hooks/api/integrations/useRetrieveIntegrations.ts';
import { useMemo } from 'react';
import { StepType } from '@/types/automationFields.ts';
import { providerUsesIntegrationInstance } from '@/utils/providerKinds.ts';

const useStepIntegration = (
  stepType: StepType | undefined,
  integrationId: string | null,
  actionType: string | null,
) => {
  const { data: integrationsData, isPending: loadingIntegrations } = useRetrieveIntegrations();

  const integrations = useMemo(() => integrationsData?.results || [], [integrationsData?.results]);

  const [selectedIntegrationProvider, selectedIntegrationInstance, selectedIntegrationAction] =
    useMemo(() => {
      for (const provider of integrations) {
        if (!providerUsesIntegrationInstance(provider) && provider.name === integrationId) {
          const actions =
            stepType === StepType.Trigger ? provider.trigger_actions : provider.dispatch_actions;
          const matchedAction = actions.find((action) => action.name === actionType);
          return [provider, undefined, matchedAction];
        } else if (providerUsesIntegrationInstance(provider)) {
          const matchedInstance = provider.instances.find(
            (instance) => instance.id === integrationId,
          );
          if (matchedInstance) {
            const actions =
              stepType === StepType.Trigger ? provider.trigger_actions : provider.dispatch_actions;
            const matchedAction = actions.find((action) => action.name === actionType);
            return [provider, matchedInstance, matchedAction];
          }
        }
      }
      return [undefined, undefined, undefined];
    }, [actionType, integrationId, integrations, stepType]);

  return {
    integrations,
    loadingIntegrations,
    selectedIntegrationProvider,
    selectedIntegrationAction,
    selectedIntegrationInstance,
  };
};

export default useStepIntegration;
